export default __webpack_public_path__ + "static/media/Bronze_MV_final.b52ad7c1.jpg";